/* eslint-disable react/no-array-index-key */
import { Text, View } from '@react-pdf/renderer';
import { VesselSpecificClaimsAdvice } from '../../../../models/pro.model';
import { formatAndRenderPdfTextContentHtml } from '../../../../utils/pro-report-helpers.utils';
import styles from '../../pro-report-pdf-styles';

interface LossPreventionCommentaryProps {
  vesselTypeSpecificClaimsAdvice: VesselSpecificClaimsAdvice[];
}

function VesselTypeSpecificLossPreventionCommentary({
  vesselTypeSpecificClaimsAdvice,
}: LossPreventionCommentaryProps) {
  if (!vesselTypeSpecificClaimsAdvice?.length) {
    return (
      <View style={styles.table}>
        <Text style={styles.tableCellFullWidth}>No advice provided.</Text>
      </View>
    );
  }
  return (
    <View style={styles.table}>
      {vesselTypeSpecificClaimsAdvice &&
        vesselTypeSpecificClaimsAdvice.length > 0 &&
        vesselTypeSpecificClaimsAdvice.map((advice, idx) => (
          <View key={idx}>
            {/* Render each summary line as a top-level <Text> for line breaks */}
            <View key="summary" style={styles.tableCellFullWidth}>
              {formatAndRenderPdfTextContentHtml(
                advice.summary,
                'No summary provided.',
                {
                  prependSubHeader: 'Summary:',
                }
              )}
            </View>
            {/* Render advice using the helper, which returns a <View> of <Text>/<Link> lines */}
            <View key="advice" style={styles.tableCellFullWidth}>
              {formatAndRenderPdfTextContentHtml(
                advice.advice,
                'No advice provided.',
                {
                  prependSubHeader: 'Advice:',
                }
              )}
            </View>
          </View>
        ))}
    </View>
  );
}

export default VesselTypeSpecificLossPreventionCommentary;
